import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as uiStrings from '../../uiStrings';

class LayerControlButton extends Component {
	constructor() {
		super();
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.refs['control-button'].addEventListener('click', () => {
			this.dispatchCustomEvent(eventNames.OPEN_LAYER_CONTROL, this.refs['control-button']);
		});
	}

	render() {
		return `
            <div ref="control-button" class="control-button layer-control--button">
                <div class="control-button__icon" title="${uiStrings.LAYERS_SELECTION}">
                    <i class="fas fa-layer-group fa-2x"></i>
                </div>
            </div>`;
	}
}

export default LayerControlButton;
